import { ReportEditionItemsModel } from '@_types/organisms';
import { getModifiers } from '@helpers/functions';
import Button from '@atoms/buttons/Button';

const ReportEditionItems = (model: ReportEditionItemsModel) => {
  const styleModifier = getModifiers(model, 'kf-o-report-edition-items');
  const { content } = model;

  return (
    <div className={styleModifier}>
      {content?.map((button, i) => (
        <p key={i}>
          <Button {...button} dataSet={{ 'data-open-form-id': 'report-edition-form', 'data-report-edition-id': 'a_Random_ReportEditionId' + i }} />
        </p>
      ))}
    </div>
  );
};

export default ReportEditionItems;
